
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21.75 17.24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M20.42 17.24H9.13a1.33 1.33 0 0 1-1.32-1.33V5.5a1.32 1.32 0 0 1 1.32-1.32h11.29a1.33 1.33 0 0 1 1.33 1.32v10.41a1.34 1.34 0 0 1-1.33 1.33zM9.13 5.36A.14.14 0 0 0 9 5.5v10.41a.14.14 0 0 0 .14.14h11.28a.14.14 0 0 0 .14-.14V5.5a.14.14 0 0 0-.14-.14z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M5.8 9.63H1.32A1.32 1.32 0 0 1 0 8.31v-7A1.32 1.32 0 0 1 1.32 0h8.77a1.32 1.32 0 0 1 1.32 1.32v.93a.58.58 0 0 1-.59.59.59.59 0 0 1-.59-.59v-.93a.14.14 0 0 0-.14-.14H1.32a.14.14 0 0 0-.14.14v7a.14.14 0 0 0 .14.14H5.8a.6.6 0 0 1 .6.54.59.59 0 0 1-.6.63zM5.61 13.9a.59.59 0 0 0-.84.82H2.14V11.1a.6.6 0 0 0-1.14 0v4.21a.59.59 0 0 0 .6.59h3.3l-.13.1a.59.59 0 0 0 0 .83.54.54 0 0 0 .41.17.59.59 0 0 0 .42-.17l1.44-1.46z"}})])])])
          )
        }
      }
    